<template>
  <form v-if="isLoaded">
    <div class="row">
      <div class="col-12">
        <!-- Pass the reasonForRejection to the TextEditor and disable it -->
        <TextEditor
            v-model="reasonForRejection"
            :inputStyle="{ height: '200px' }"
            label="Beschreibung"
            :readOnly="true"
            :disabled="true" />
      </div>
    </div>
  </form>
</template>

<script setup>
import TextEditor from '@/components/TextEditor.vue';
import { defineProps, ref, toRefs } from 'vue';

const isLoaded = ref(true);

// Props for the text field (reasonForRejection)
const props = defineProps({
  reasonForRejection: {
    type: String,
    required: true,
  },
});

const { reasonForRejection } = toRefs(props);
</script>

<style scoped>
/* Any custom styles */
</style>
